import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { settingDetails } from "../../../../stores/actions/settings.actions.types";
import AddEmailFooterForm from "../../../Forms/AddEmailFooter";
import { BiLoaderAlt } from "react-icons/bi";

const EmailFooterPage = ({ settingDetails }) => {
  const [setting, setSetting] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    settingDetails({
      callback: (data) => {
        setLoading(false);
        if (data?.success) {
          setSetting(data?.data?.setting);
        }
      },
    });
  }, [settingDetails]);

  return (
    <div>
      {loading ? (
        <div className='flex m-6 dark:bg-boxdark rounded-[10px] bg-white items-center justify-center min-h-96'>
          <BiLoaderAlt className='animate-spin text-4xl text-primary dark:text-white' />
        </div>
      ) : (
        <AddEmailFooterForm setting={setting} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});
export default connect(mapStateToProps, {
  settingDetails,
})(EmailFooterPage);
